import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TitleComponent } from '@shared/components/title';
import { HeadingTag, Title } from '@shared/components/title/models';
import { HandleHtmlLinksDirective } from '@shared/directives';

@Component({
  selector: 'app-card-title-text-html',
  imports: [TitleComponent, HandleHtmlLinksDirective],
  templateUrl: './card-title-text-html.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardTitleTextHtmlComponent {
  title = input<Title>();
  text = input<string>();
  size = input<HeadingTag>('custom-18-35');
}
